export default {
	list: [],
	hasNetwork: (typeof navigator !== "undefined" && typeof navigator.onLine === "boolean") ? navigator.onLine : false,
};
